import React, {Component} from 'react';
import * as func from "../../../../utils/functions";
import {BASE_PATH} from "../../../../wpconfig";
import MDItem from "./item/mditem";

class MailHistoryDetail extends Component {
  constructor(props) {
    super(props);
    const p = func.parseParams(location.search.substring(1))

    this.state = {
      isInit: false,
      param: {
        // 'record_id' : 1,
        'record_id' : p['record_id'] ? p['record_id'] : '',
      },
      records: [],
      totalRecords: 0,
      totalPage: 0,
      action : 'sendmail/history/detail',
      url: 'wp-admin/admin.php?page=researchmind-mail&',
    }
  }
  componentDidMount() {
    // 이해 안됨.
    setTimeout(() => {
      this.getDetailList();
    }, 0);
  }

  getDetailList(param = {}) {
    if(Object.keys(param).length > 0) {
    } else {
      param = this.state.param
    }
    func.getData(this.state.action, param).then((response) => {
      this.setState({
        isInit: true,
        records: response.records,
        totalRecords: response.pageInfo.totalResults,
        totalPage: response.pageInfo.totalPage,
      })
    });
  }

  getListUrl() {
    return func.removeParamUrl('record_id');
  }
	render() {
		return (
      <div className="container-fluid mt-3 admin-layout">
        <div className="row">
          <div className="col-12 admin-contents mb-2">
            <a href={this.getListUrl()} className="btn btn-sm btn-secondary order-1" type="button" id="show_list">리스트보기</a>
          </div>
        </div>

        <div className="row">
          <div className="col-12 admin-contents">
            <table className="table table-striped table-thin border-bottom sendmail-history-detail">
              <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">이메일</th>
                <th scope="col">연구자</th>
                <th scope="col">소속</th>
                <th scope="col">국가</th>
                <th scope="col">논문ID</th>
                <th scope="col">저자ID</th>
                <th scope="col">메일열람</th>
                <th scope="col">사이트접속</th>
              </tr>
              </thead>
              <tbody>
              {!this.state.isInit && this.state.records.length <= 0 && <tr>
                <td colSpan={16}>로딩중입니다.</td>
              </tr>}
              {this.state.isInit && this.state.records.length <= 0 && <tr>
                <td colSpan={16}>결과가 없습니다.</td>
              </tr>}
              {this.state.records.map((record, index) => {
                return (
                  <MDItem key={record.ID} record={record} url={BASE_PATH + this.state.url} />
                )
              })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
	}
}

export default MailHistoryDetail;
